import { UserRole } from "../../../common/enums";
import { dateUtility } from "../../../common/infrastructure/utilities/dateUtility";
import { IReviewFormModel } from "../models/reviewFormModel";

const REVIEW_MANAGER_ROLES = [
  UserRole.Tenant,
  UserRole.Employee_Manager,
  UserRole.GlobalAdmin,
];

/** The "Ревюта" administration is for the owner, managers and Planny's own team. */
export const canManageReviews = (role?: UserRole): boolean =>
  role !== undefined && REVIEW_MANAGER_ROLES.includes(role);

/** What the API takes for a review: a trimmed comment, or none when it is blank. */
export const toReviewPayload = ({ rating, comment }: IReviewFormModel) => {
  const trimmed = comment?.trim() ?? "";
  return { rating, comment: trimmed.length > 0 ? trimmed : null };
};

export const formatReviewDate = (date?: string | null) =>
  dateUtility.formatDate(date, "dd.MM.yyyy");

/** "1 звезда", "2 звезди" … — the names of the star buttons. */
export const getStarLabel = (stars: number) =>
  stars === 1 ? "1 звезда" : `${stars} звезди`;

export const formatAverageRating = (average: number) => average.toFixed(1);

/** The line under "Благодарим за ревюто!", warmer for a good visit, apologetic for a bad one. */
export const getThankYouMessage = (rating: number, studioName: string) => {
  if (rating >= 4) {
    return `Радваме се, че ви е харесало в ${studioName}. Очакваме ви отново!`;
  }
  if (rating === 3) {
    return `Благодарим, че споделихте. Ще се постараем следващото ви посещение в ${studioName} да е още по-добро.`;
  }
  return "Съжаляваме, че не беше както трябва. Ще прочетем внимателно отзива ви и ще го вземем предвид.";
};

export const getReviewsCountLabel = (count: number) =>
  count === 1 ? "1 ревю" : `${count} ревюта`;

/** A shuffled copy (Fisher–Yates); the original list is left as it is. */
export const shuffleReviews = <T,>(items: readonly T[]): T[] => {
  const result = [...items];
  for (let i = result.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [result[i], result[j]] = [result[j], result[i]];
  }
  return result;
};

/** The dialog's shuffle seed: the API orders its pages by it, 1 to 1 000 002. */
export const createReviewsSeed = () => Math.floor(Math.random() * 1_000_002) + 1;
